import gql from 'graphql-tag';
import { DELIVERY } from '../deliveries/fragments';
import { LOADING } from '../loadings/fragments';

export const CONTAINER = gql`
  ${DELIVERY}
  fragment container on Container {
    deliveries { ...delivery }
    id
    blNumber
  }
`;
export const CONTAINER_LOADING = gql`
  ${LOADING}
  fragment container on Container {
    loadings { ...loading }
    id
    blNumber
  }
`;
